import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { listCushionChargePolicies } from 'api/company/listCushionChargePolicies'
import { cushionChargePoliciesKey } from './keys'

type UseCushionChargePoliciesQueryData = Awaited<
  ReturnType<typeof listCushionChargePolicies>
>
type UseCushionChargePoliciesQueryKey = ReturnType<
  typeof cushionChargePoliciesKey
>
type UseCushionChargePoliciesQueryOptions = Partial<
  UseQueryOptions<
    UseCushionChargePoliciesQueryData,
    Error,
    UseCushionChargePoliciesQueryData,
    UseCushionChargePoliciesQueryKey
  >
>

export function useCushionChargePoliciesQuery(
  companyId: number,
  options: UseCushionChargePoliciesQueryOptions = {}
) {
  return useQuery({
    ...options,
    queryKey: cushionChargePoliciesKey(companyId),
    queryFn: () => listCushionChargePolicies(companyId),
    enabled: !!companyId && options.enabled !== false,
  })
}
